import { Paragraph, Show } from '@welbe/web-design-system';
import { useMemo } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { Content, DropdownContent, Wrapper } from './Dropdown.styles';

type DropdownProps = {
	options: { label: string; value: string }[];
};

export const Dropdown = ({ options }: DropdownProps) => {
	const renderDropdownTextContent = useMemo(() => {
		if (options.length === 1) return options[0].label;

		return (
			<>
				<Paragraph> Colaboradores ({options.length})</Paragraph>
				<IoIosArrowDown />
			</>
		);
	}, [options]);

	return (
		<Wrapper>
			<Content>{renderDropdownTextContent}</Content>
			<Show when={options.length > 1} fallback={null}>
				<DropdownContent>
					{options.map((option) => {
						return <Paragraph key={option.value}>{option.label}</Paragraph>;
					})}
				</DropdownContent>
			</Show>
		</Wrapper>
	);
};
